import { Injectable } from '@angular/core'
import { HtmlParserService } from './html-parser.service'

@Injectable({
  providedIn: 'root',
})
export class HtmlParserBrowserService implements HtmlParserService {
  private browserDomParser = new DOMParser()

  public textContent(html: string): string {
    return this.parseFromString(html).body.textContent || ''
  }

  public parseFromString(html: string): Document {
    return this.browserDomParser.parseFromString(html, 'text/html')
  }
}
